import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{!\n  Copyright (c) HashiCorp, Inc.\n  SPDX-License-Identifier: MPL-2.0\n}}\n\n<path d={{this.d}} ...attributes></path>\n{{yield (hash centroid=this.centroid)}}\n")